import styled from 'styled-components';

const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
  background: #eae6dc;

  @media (max-width: 768px) {
    padding: 18px;
  }
`

Box.Container = styled.div`
  max-width: 420px;
  width: 100%;
`

Box.Content = styled.div`
  border-radius: 24px;
  padding: 48px 40px 40px;
  background: #f5f2eb;
  border: 1px solid rgba(212, 205, 191, 0.88);
  box-shadow: 0 32px 80px rgba(44, 42, 32, 0.14);

  @media (max-width: 768px) {
    padding: 32px 24px 28px;
  }
`

Box.Logo = styled.img`
  max-width: 180px;
`

export default Box
